export default {
	LIST_TOGGLE_FILTER: 'LIST_TOGGLE_FILTER',
	LIST_FILTER_CHANGE: 'LIST_FILTER_CHANGE',
	LIST_CHANGE_SORT_ORDER: 'LIST_CHANGE_SORT_ORDER',
};
